import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import {
  getWebPageVariant,
  WebPageType,
} from '../../../../constants/webPageType';
import { Profile } from '../../../../models/UserStore';
import { AvatarNode } from '../../AvatarNode';
import { SvgIcon } from '../../SVGIcon';
import { GeneralModal, GeneralModalNoButtonVariant } from '../GeneralModal';

import './ResetPasswordModal.css';

type ResetPasswordModalProps = {
  profile: Profile | undefined | null;
  email: string;
  webPageType: WebPageType;
  onClose: () => void;
};

export const ResetPasswordModal = memo(
  ({ profile, email, webPageType, onClose }: ResetPasswordModalProps) => {
    const { t } = useTranslation();
    return (
      <GeneralModal
        onClose={onClose}
        buttonSetting={{
          noText: t('OK'),
          noVariant: getWebPageVariant(webPageType).generalModalNoButtonVariant,
        }}
      >
        <div className="reset-password-general">
          <div className="centered-container">
            {profile && <AvatarNode profile={profile} size={125} />}
            <div className="username">{profile?.name}</div>
            <div className="email">{email}</div>

            <div className="sub-title">
              {t(
                'You should receive an email to reset your password within 5 minutes.',
              )}
            </div>
            <div className="content">
              {t('Please also check your spam / junk box.')}
            </div>
          </div>
        </div>
      </GeneralModal>
    );
  },
);

type ResetPasswordResendModalProps = {
  email: string;
  countDown: number;
  webPageType: WebPageType;
  onClose: () => void;
  onYes: () => void;
};

export const ResetPasswordResendModal = memo(
  ({
    email,
    countDown,
    webPageType,
    onClose,
    onYes,
  }: ResetPasswordResendModalProps) => {
    const { t } = useTranslation();
    return (
      <GeneralModal
        isYesNo={true}
        onClose={onClose}
        onYes={onYes}
        buttonSetting={{
          noText: t('Close'),
          noVariant: GeneralModalNoButtonVariant.Gray,
          yesText: t('Resend'),
          yesCountDown: countDown,
          yesVariant:
            getWebPageVariant(webPageType).generalModalYesButtonVariant,
        }}
      >
        <div className="reset-password-general">
          <div className="centered-container">
            <SvgIcon
              name={SVGIconType.CircleTick}
              color="black"
              width={100}
              height={100}
            />
            <div className="username">{t('Email Sent')}</div>
            <div className="email">{email}</div>

            <div className="sub-title">
              {t(
                'You should already received an email to reset your password.',
              )}
            </div>
            <div className="content">
              {t('Please also check your spam / junk box.')}
            </div>
          </div>
        </div>
      </GeneralModal>
    );
  },
);
